/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 1/14/14
 * Time: 3:08 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/tooltipContainerView.tmpl");
    var TooltipListView = require("manager-views/data-sources/attributes/TooltipListView");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var KpContent = require("ui.components/kpContent/kpContent");

    var TooltipContainerView = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        TooltipContainerView = Backbone.Marionette.ItemView.extend({
            template: template,
            className: "tab-why-choose",
            ui: {
                "pros": ".items-list-pros",
                "cons": ".items-list-cons",
                "kpContainer": ".kp-container"
            },
            uiComponents:{
                prosList: {
                    type: TooltipListView,
                    options: {
                        el: "view.ui.pros",
                        collection: "view.getItemsProsCollection"
                    }
                },
                consList: {
                    type: TooltipListView,
                    options: {
                        el: "view.ui.cons",
                        collection: "view.getItemsConsCollection"
                    }
                }
            },

            initialize: function(options) {
                LEManager.logger.debug("TooltipContainerView:initialize");
                this.tooltipArray = options.tooltipArray;
                this.displayKP = options.displayKP;
                this.KPResources = options.KPResources || "";
                this.tabType = options.tabType;
            },

            onRender: function(){
                LEManager.logger.debug("TooltipContainerView:onRender - displayKP: " + this.displayKP);
                if (this.displayKP){
                    this.uiComponents.host$.createAndRender("kpContent", {
                        type : KpContent,
                        options : {
                            contentPermutation: KpContent.CONTENT_PERMUTATION.TOP,
                            container: "view.ui.kpContainer",
                            KPLink: LE.translator.translate('LEManager.manager.dataSources.edit.tab.kp.caption.' + this.tabType),
                            kpID: this.KPResources
                        }
                    });
                }
            },

            getItemsProsCollection: function(){
                LEManager.logger.debug("TooltipContainerView:getItemsProsCollection");
                var pros = this.tooltipArray[ManagerConfig.dataSources.mapping.editItem.PROS];
                return new Backbone.Collection(pros);
            },

            getItemsConsCollection: function(){
                LEManager.logger.debug("TooltipContainerView:getItemsConsCollection");
                var cons = this.tooltipArray[ManagerConfig.dataSources.mapping.editItem.CONS];
                return new Backbone.Collection(cons);
            },

            onClose: function(){
                LEManager.logger.debug("TooltipContainerView:onClose");
            }
        });
    });


    return TooltipContainerView;
});